
import * as React from "react";
import * as $ from "jquery";
import {ImageEditorCanvas} from './ImageEditorCanvas';
import {ScrollCanvas} from './ScrollCanvas';
interface IImageEditorProps {
    img    : string;
    x      : number;
    y      : number;
    scale  : number;
    width  : number;
    height : number;
    refreshCanvas :Function;
}

interface IImageEditorState {
}
interface MyWindows extends Window{
	canvasParameters: any;
}
export class ImageEditor extends React.Component<IImageEditorProps, IImageEditorState>{

    private Editor:ImageEditorCanvas;
    constructor(props:IImageEditorProps){
          super(props);
          this.Editor = null;
          this.state = this.getInitState();
    }

    protected getInitState():any{
        return {
        };
    }

    private editorLeaveHandler(evt): void {
		if ( evt !== undefined ) {
			evt.preventDefault();
		}
        if ( this.Editor !== null ) {
            var positions:any = this.Editor.getParameters();
            if ( (window as MyWindows).canvasParameters === undefined ) {
                (window as MyWindows).canvasParameters = null;
            }
            if ( (window as MyWindows).canvasParameters !== JSON.stringify(positions) ) {
                (window as MyWindows).canvasParameters = JSON.stringify(positions);
                this.props.refreshCanvas(positions);
            }
        }
    }

    private modifyScrollHandler(evt, plus:boolean): void {
        evt.preventDefault();
        var newScale:number = this.props.scale;
        if ( plus === true ) {
            newScale += 0.1;
        }else{
            newScale -= 0.1;
        }
        this.Editor.resizeImage(newScale*100);
        this.editorLeaveHandler(evt);
    }

    render() {
        var scale:number = this.props.scale;
        setTimeout(()=>{
            this.Editor = new ImageEditorCanvas(this.props.x, this.props.y, this.props.width, this.props.height, this.props.img, scale);
            // tslint:disable-next-line:no-unused-expression
            new ScrollCanvas(scale*100, this.props.width, 25, '/img/v2/part2/pocok.png', 'scroll_image', false, (percent)=>{
                this.Editor.resizeImage(percent);
            });
        },100);
        return (
            <div>
                <canvas id="image_editor" onMouseLeave={ e => this.editorLeaveHandler(e) }></canvas>
                <div className="scrollBar hide">
                    <div className="title">
                        Kép nagyítása
                    </div>
                    <div className="canvas_parent">
                        <a className="scrollDown_btn" onClick={ (e) => { this.modifyScrollHandler(e,false); } }></a>
                        <canvas id="scroll_image" onMouseLeave={ e => this.editorLeaveHandler(e) }></canvas>
                        <a className="scrollUp_btn" onClick={ (e) => { this.modifyScrollHandler(e,true); } }></a>
                    </div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./lib/components/ImageEditor.tsx